import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <p>© 2024 Sirius Music Group. All rights reserved.</p>
      <div className="social-icons">
        <a href="#" target="_blank" rel="noopener noreferrer">🎵 Instagram</a> | 
        <a href="#" target="_blank" rel="noopener noreferrer">🎶 Twitter</a> | 
        <a href="#" target="_blank" rel="noopener noreferrer">📺 YouTube</a>
      </div>
    </footer>
  );
};

export default Footer;